import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";

export default function IssueRegisterForm({
  subId,
  onSubmit,
  rowData,
  project,
}) {
  console.log(rowData, "---");
  const location = useLocation();
  const pro = project || location.state;

  const [workPackages, setWorkPackages] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [workPackageId, setWorkPackageId] = useState("");
  const [taskId, setTaskId] = useState();
  const [formData, setFormData] = useState({
    projectName: pro?.Project_Name || "",
    IssueID: "",
    productCategory: pro?.Product_Category || "",
    location: pro?.Location || "",
    issueDescription: "",
    impactDescription: "",
    impactLevel: "",
    priorityLevel: "",
    issueStatus: "",
    mitigationStrategy: "",
    assignedPersonEmail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const state = JSON.parse(localStorage.getItem("state"));
    if (onSubmit) onSubmit();

    const issueData = {
      ProjectID: pro?.project_id,
      TaskID: taskId,
      IssueID: formData?.IssueID,
      ProjectName: pro?.Project_Name,
      ProductCategory: pro?.Product_Category,
      ProjectName: formData.projectName,
      ProductCategory: formData.productCategory,
      Location: formData.location,
      IssueDescription: formData.issueDescription,
      ImpactDescription: formData.impactDescription,
      ImpactLevel: formData.impactLevel,
      PriorityLevel: formData.priorityLevel,
      IssueStatus: formData.issueStatus,
      IsRiskintoIssue: "No",
      MitigationStrategy: formData.mitigationStrategy,
      AssignedPersonEmail: formData.assignedPersonEmail,
      UserID: state.user.user_id,
    };
    const saveIssue = await DPR_API.SaveIssueDetails(issueData);
    if (saveIssue && saveIssue?.status === 201) {
      toast.success(saveIssue?.Message, { autoClose: 2000 });
    } else {
      toast.error(saveIssue?.Message, { autoClose: 2000 });
    }
  };
  const fetchWorkPackage = async () => {
    let state = JSON.parse(localStorage.getItem("state"));

    let obj = {
      EmailID: state.user.Email,
      ProjectGUID: pro?.ProjectGUID,
    };
    const dpr = await DPR_API.GetProjectWorkPackage(obj);
    setWorkPackages(dpr.WorkPackagelList || []);
  };
  const fetchTasks = async (workPackageId) => {
    const dprResponse = await DPR_API.getDprDetails(workPackageId);
    if (dprResponse && dprResponse?.subtasks?.length > 0) {
      setTasks(dprResponse?.subtasks);
    } else {
      setTasks([]);
    }
  };
  useEffect(() => {
    fetchWorkPackage();
    if (rowData) {
      setFormData({
        projectName: rowData.ProjectName || "",
        productCategory: rowData.ProductCategory || "",
        location: rowData.ProjectLocation || "",
        issueDescription: rowData.IssueDescription || "",
        impactDescription: rowData.ImpactDescription || "",
        impactLevel: rowData.ImpactLevel || "",
        priorityLevel: rowData.PriorityLevel || "",
        issueStatus: rowData.IssueStatus || "",
        mitigationStrategy: rowData.MitigationStrategy || "",
        assignedPersonEmail: rowData.AssignedPersonEmail || "",
        TaskID: rowData.TaskID || "",
        IssueID: rowData.IssueID,
      });
    }
  }, []);
  useEffect(() => {
    // if (!subId || !rowData) {
    if (!subId) {
      fetchTasks(workPackageId);
    } else {
      setTaskId(subId);
    }
  }, [workPackageId]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-6">
          <label className="label-custom">Project Name</label>
          <input
            disabled
            type="text"
            name="projectName"
            value={formData.projectName}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Product Category</label>
          <input
            disabled
            type="text"
            name="productCategory"
            value={formData.productCategory}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      {!subId && (
        <>
          <div className="row mt-2">
            <div className="col-6">
              <label className="label-custom">WorkPackage</label>
              <select
                name="workpackage"
                id="workpackage"
                onChange={(e) => {
                  setWorkPackageId(e.target.value);
                  setTaskId("");
                }}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="">select workpackge</option>
                {workPackages.map((val) => (
                  <option value={val?.WorkPackageID}>
                    {val?.WorkPackageName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6">
              <label className="label-custom">Task</label>
              <select
                name="task"
                id="task"
                className="filter-label"
                value={taskId}
                onChange={(e) => setTaskId(e.target.value)}
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="">select task</option>
                {tasks.map((val) => (
                  <option value={val?.DPRID}>{val?.Subtask}</option>
                ))}
              </select>
            </div>
          </div>
        </>
      )}
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Location</label>
          <input
            disabled
            type="text"
            name="location"
            value={formData.location}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        {/* <div className="col-6">
          <label className="label-custom">Activity/Task</label>
          <input
            type="text"
            name="activityTask"
            value={formData.activityTask}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div> */}
        <div className="col-6">
          <label className="label-custom">Assigned Person Email</label>
          <input
            type="email"
            name="assignedPersonEmail"
            value={formData.assignedPersonEmail}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Issue Description</label>
          <textarea
            name="issueDescription"
            value={formData.issueDescription}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Impact Description</label>
          <textarea
            name="impactDescription"
            value={formData.impactDescription}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Impact Level</label>
          <input
            type="text"
            name="impactLevel"
            value={formData.impactLevel}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Priority Level</label>
          <input
            type="text"
            name="priorityLevel"
            value={formData.priorityLevel}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Issue Status</label>
          <select
            name="issueStatus"
            value={formData.issueStatus}
            className="filter-label"
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
            onChange={handleChange}
          >
            <option value="">--Select status--</option>
            <option value="Open">Open</option>
            <option value="Resolved">Resolved</option>
          </select>
        </div>
        <div className="col-6">
          <label className="label-custom">Mitigation Strategy</label>
          <textarea
            name="mitigationStrategy"
            value={formData.mitigationStrategy}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
          <div className="m-2">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                onSubmit();
                setFormData({});
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
